import React from 'react';
import { ButtonGroup } from '@atlaskit/button';
import Button from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import type { SuggestedCommentReplyAgentCommentType } from '@atlassian/jira-ai-assistance-service-client/src/services/ai-features-client/suggested-comment-reply-agent/types.tsx';
import { useAICommentsStates } from '../../../controllers/use-ai-comments-context/index.tsx';

export const CommentButtonGroup = ({
	onButtonClick,
}: {
	onButtonClick: (commentType: SuggestedCommentReplyAgentCommentType) => void;
}) => {
	const { formatMessage } = useIntl();
	const [{ availableCommentTypeOptions }] = useAICommentsStates();

	return (
		<ButtonGroup label="">
			{availableCommentTypeOptions.map((option) => (
				<Button
					spacing="compact"
					onClick={() => onButtonClick(option.value)}
					key={option.value}
					aria-label={formatMessage(option.message)}
				>
					{formatMessage(option.message)}
				</Button>
			))}
		</ButtonGroup>
	);
};
